import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

import IconAction from '#app/Component/IconAction';
import ShadowBoxComponent from '#app/Component/ShadowBoxComponent';
import TitleComponent from '#app/Component/TitleComponent';
import { getRoutePathname } from '#app/Handler/RouteHandler';
import { History } from '#app/typings/order';

type Props = {
  history: History;
};

const OrderHistory: React.FC<Props> = ({ history }) => {
  const classes = useStyles();

  return (
    <Grid item md={12} lg={4} xl={3}>
      <ShadowBoxComponent className={classes.box}>
        <TitleComponent title="Historique" />
        <div className={classes.container}>
          <div>
            <b>Créée le : </b> {history.createdAt ?? '-'}
          </div>
          <div>
            <b>Confirmée le : </b> {history.confirmedAt ?? '-'}
          </div>
          <div>
            <div>
              <b>Préparée le : </b> {history.inPreparationAt ?? '-'}
            </div>
            <div>
              <b>Par : </b> {history.userPreparer ?? '-'}
            </div>
          </div>
          <div>
            <b>Colisage le : </b> {history.packagingAt ?? '-'}
          </div>
          <div>
            <div>
              <b>En transit le : </b> {history.inTransitAt ?? '-'}
            </div>
            <div>
              <b>Code : </b> {history.numberCarrier ?? '-'}
            </div>
          </div>
          <div>
            <b>Terminée le : </b> {history.completedAt ?? '-'}
          </div>
          <div>
            <div>
              <b>Annulé le : </b> {history.cancelAt ?? '-'}
            </div>
            <div>
              <b>Par : </b> {history.authorCancel ?? '-'}
            </div>
          </div>

          {history.forwardingUuid && (
            <div>
              <b>Réexpédié le : </b> {history.forwardingAt}
              <IconAction
                title="Visualisation la commande réexpédiée"
                icon="view"
                to={getRoutePathname('sale_order_client', { uuid: history.forwardingUuid })}
              />
            </div>
          )}
          {history &&
            history.orderClientCredits.map((orderClientCredit, key) => (
              <div key={key}>
                <b>Remboursé le : </b> {orderClientCredit.refundAt}
              </div>
            ))}
        </div>
      </ShadowBoxComponent>
    </Grid>
  );
};

const useStyles = makeStyles({
  box: {
    height: '100%',
  },
  container: {
    fontSize: 12,
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  article: {
    color: '#17a2b8',
    fontSize: 17,
    position: 'absolute',
    right: -5,
    top: -2,
  },
});

export default OrderHistory;
